import { apiClient } from "./apiClient";
import { IEmployeeInfoResponse, IEmployeesResponse } from "../features/employees/Interfaces/IEmployeeInterface";

export async function getEmployees(page = 1, pageSize = 5): Promise<IEmployeesResponse> {
  const { data } = await apiClient.get<IEmployeesResponse>(
    `/employees?page=${page}&pageSize=${pageSize}`
  );
  return data;
}

export async function getEmployeesWithEvaluations(page = 1, pageSize = 5): Promise<IEmployeesResponse> {
  const { data } = await apiClient.get<IEmployeesResponse>(
    `/employees/with-evaluations?page=${page}&pageSize=${pageSize}`
  );
  return data;
}

export async function getEmployeesMinimal(): Promise<IEmployeesResponse> {
  const { data } = await apiClient.get<IEmployeesResponse>("/employees/employees-minimal");
  return data;
}

export async function getEmployeesMinimalExcludeCurrentAndTeamLeaders(): Promise<IEmployeesResponse> {
  const { data } = await apiClient.get<IEmployeesResponse>("/employees/employees-minimal/exclude-current-and-team-leaders");
  return data;
}

export async function getEmployeeInfo(employeeId: string): Promise<IEmployeeInfoResponse> {
  const { data } = await apiClient.get<IEmployeeInfoResponse>(`/employees/${employeeId}`);
  return data;
}

